var queryString = require('query-string');

var templateCart = require('pug-loader!../../../views/blocks/cart.pug');
var templateCartMobile = require('pug-loader!../../../views/blocks/navbar/cart-mobile.pug');
var templateSingleShoppingList = require('pug-loader!../../../views/shop-list/single/shopping-list-template.pug');
var templateProductPage = require('pug-loader!../../../views/product/components/product-section-single-page.pug');
const cartConfirmationModal = require('pug-loader!../../../views/blocks/modals/added-to-cart-confirmation.pug');
const shoppingListModalTemplate = require('pug-loader!../../../views/blocks/modals/shopping-list-modal.pug');

var config;
var that;
var ShoppingListController = {
  config: {},

  init: function() {
    that = this;
    config = this.settings;
    this.bindUIElements();
    $(window).trigger('initShoplistsQuantityInputs');
  },

  bindUIElements: function() {
    var _t = this;
    //add to cart

    $('#add-to-wishlist-modal-trigger').on('click', function(ev) {
      ev.preventDefault();

      // open wishlist modal with all the wishlists
      _t.openShoppingListModal($(ev.currentTarget).attr('prod-id'));
    });

    //remove from cart
    $('.delete-list-item-trigger').on('click', _t.removeFromList);

    window.addEventListener(
      'triggerUpdateQuantityShoplist',
      function(e) {
        // e.target matches elem
        // console.log(e);

        _t.updateQuantityInList(e.detail.prod_id, e.detail.shoplist_id, e.detail.qty)
          .then(function(data) {
            _t.updateSingleListWrapper(e.detail.element, data);

            return;
          })
          .catch(function(err) {
            alert('Error ocurred. Please try again later.');
          });
        //get quantity and prod_id and make post request
      },
      false
    );
  },

  removeFromList: function(ev) {
    ev.preventDefault();
    let element = this;
    var prodId = $(ev.currentTarget).attr('prod-id');
    var shoplistId = $(ev.currentTarget).attr('shoplist-id');

    jQuery
      .ajax({
        type: 'DELETE',
        url: '/shoppinglist/item',
        data: {
          shopping_list_item_prod_id: prodId,
          id: shoplistId
        }
      })
      .then(function(data) {
        that.updateSingleListWrapper(element, data);
        that.bindUIElements();
        return;
        // console.log("done");
        // console.log(data);
      })
      .catch(function(data) {
        alert('Error ocurred. Please try again later.');
      });
  },

  updateQuantityInList: function(shopping_list_item_prod_id, shopping_list_id, qty) {
    return jQuery.ajax({
      type: 'POST',
      url: '/shoppinglist/update',
      data: {
        shopping_list_item_prod_id,
        id: shopping_list_id,
        qty
      }
    });
  },

  updateSingleListWrapper: function(el, data) {
    var _t = this;
    var locals = {
      item: data
    };
    var html = templateSingleShoppingList(locals);
    $(el)
      .closest('.shop-list-wrapper')
      .html(html);

    //rebind quantity buttons
    $(window).trigger('initShoplistsQuantityInputs');

    //rebind delete buttons
    $('.delete-list-item-trigger')
      .off()
      .on('click', _t.removeFromList);
  },

  openShoppingListModal: function(productId) {
    var _t = this;
    // show loading screen

    var locals = {
      prod_id: productId
    };
    var html = shoppingListModalTemplate(locals);

    $('body').append(html);

    $('#shopping-list-modal').on('shown.bs.modal', function() {
      _t.getShoppingLists()
        .then(function(data) {
          // data is array
          _t.updateList(data);

          $('#wishlist-loading-spinner').fadeOut('slow', function() {
            $('#wishlist-form').css('display', 'block');

            $('#wishlist-select option:eq(1)')
              .prop('selected', true)
              .change();
          });

          return;
        })
        .catch(function(err) {
          // console.log(err);
          $('#wishlist-loading-spinner').fadeOut('slow', function() {
            //callback show alert danger
            $('#wishlist-alert')
              .addClass('alert alert-danger')
              .html('There was a problem with your request. Please try again later.');
          });
        });

      //bind newly created function
      $('#add-new-wishlist-trigger').on('click', _t.addNewWishlist.bind(_t));

      //submit add item to shopping-list request
      $('#wishlist-form').submit(function(ev) {
        ev.preventDefault();
        let $form = $(this),
          url = $form.attr('action');

        jQuery
          .ajax({
            type: 'POST',
            url: url,
            data: $form.serialize()
          })
          .then(function(data) {
            //on success update data
            _t.updateShoppingListItems(data);
            return;
          })
          .catch(function(e) {
            console.log(e);
          });
      });

      // @todo on select get details of list
      // @todo check if the item is in the selected wishlist
      // @todo if it is show a message and choose to delete
      $('#wishlist-select').on('change', function() {
        if (this.value != -1) {
          _t.toggleAddNewShoppingListForm('hide');

          //option to add to current wishlist
          _t.getItemsOfList(this.value)
            .then(data => {
              return _t.updateShoppingListItems(data);
            })
            .catch(err => {
              //show error message;
            });
        } else {
          //option to create new wishlist selected
          _t.toggleAddNewShoppingListForm('show');
        }
      });
    });

    $('#shopping-list-modal').on('hidden.bs.modal', function(e) {
      $('#shopping-list-modal').remove();
    });

    $('#shopping-list-modal').modal('show');
  },

  toggleAddNewShoppingListForm: function(action) {
    let element = $('#add-new-shopping-list-form-wrapper');

    if (action === 'hide') {
      element.addClass('hidden');
    } else {
      //clear shoppinglist items
      $('#selected-wishlist-items').html('');
      element.removeClass('hidden');
    }
  },

  getShoppingLists: function() {
    return new Promise((resolve, reject) => {
      jQuery
        .ajax({
          type: 'GET',
          url: '/shoppinglist/all'
        })
        .then(function(data) {
          return resolve(data);
        })
        .catch(function(err) {
          return reject(err);
        });
    });
  },

  getItemsOfList: function(listId) {
    var _t = this;
    return new Promise((resolve, reject) => {
      jQuery
        .ajax({
          type: 'GET',
          url: `/shoppinglist/${listId}`
        })
        .then(function(data) {
          return resolve(data);
        })
        .catch(function(err) {
          return reject(err);
        });
    });
  },

  updateShoppingListItems: function(data) {
    //expect array of items
    let html = '';
    if (data.length) {
      let shoplistTotal = 0;
      html += '<ul class="list-unstyled">';
      html +=
        '<li><div class=\'row\'><div class="col-xs-6"></div><div class="col-xs-3">Quantity</div><div class="col-xs-3">Subtotal</div></div></li>';
      for (let i = 0; i < data.length; i++) {
        var itemTotal =
          parseFloat(data[i].food_product.prod_final_price) * parseFloat(data[i].shopping_list_item_prod_qty);
        shoplistTotal += itemTotal;
        html += `<li>
                <div class="row">
                    <div class="col-xs-6">
                        <a href="/product/${data[i].shopping_list_item_prod_id}">
                            <h4>${data[i].food_product.prod_name}<br>
                            <small>${data[i].food_product.prod_final_price.toFixed(2)}€</small></h4>
                        </a>
                    </div>
                    <div class="col-xs-3">
                        <h5>
                        ${data[i].shopping_list_item_prod_qty}</h5></div>
                    <div class="col-xs-3">
                        <h5>${itemTotal.toFixed(2)}€</h5></div>    
                </div>


                 </li>`;
      }
      html +=
        '<li class="padding-vertical-bottom-3em"><div class=\'row\'><div class="col-xs-6"></div><div class="col-xs-3"><h4 class="font-weight-500">Total</h4></div><div class="col-xs-3"><h4 class="font-weight-500">' +
        shoplistTotal.toFixed(2) +
        '€</h4></div></div></li>';
      html += '</ul>';
    } else {
      html += `<div class="alert alert-info margin-top-1"><p>There are no items in the selected list</p></div>`;
    }

    jQuery('#selected-wishlist-items').html(html);
  },

  addNewWishlist: function() {
    var _t = this;

    jQuery
      .ajax({
        type: 'POST',
        url: '/shoppinglist',
        data: {
          name: $('#wishlist-name').val()
        }
      })
      .then(function(data) {
        // data is array
        _t.updateList(data);

        console.log(data);

        $('#add-new-wishlist-status')
          .html('Shopping list successfully created.')
          .addClass('alert-success')
          .css('display', 'block')
          .fadeIn('slow', function() {
            setTimeout(function() {
              $('#add-new-wishlist-status')
                .removeClass('alert-success')
                .fadeOut();
              _t.toggleAddNewShoppingListForm();

              // var len = $('#wishlist-select option').length;
              let index = data[data.length - 1].shopping_list_id;
              $('#wishlist-select option[value=' + index + ']').prop('selected', true);
              $('#wishlist-select option').change();
            }, 1000);
          });

        return;
      })
      .catch(function(err) {
        $('#add-new-wishlist-status')
          .html(err.responseJSON.error)
          .addClass('alert-danger')
          .css('display', 'block')
          .fadeIn('slow', function() {
            setTimeout(function() {
              $('#add-new-wishlist-status')
                .removeClass('alert-danger')
                .fadeOut();
            }, 3000);
          });
        // console.log(err);
      });
  },

  updateList: function(data) {
    $('#wishlist-select')
      .html('')
      .append('<option selected disabled hidden>Choose your shopping list</option>');

    if (data.length) {
      //clear previous list

      for (var i = 0; i < data.length; i++) {
        //add new list
        $('#wishlist-select').append(
          $('<option>', {
            value: data[i].shopping_list_id,
            text: data[i].shopping_list_name
          })
        );
      }
    } else {
      $('#wishlist-alert')
        .addClass('alert alert-info')
        .html('There are no shopping lists created for your account. Create one right now');
    }

    $('#wishlist-select').append('<option value="-1">Create new shopping list...</option>');

    return;
  },

  removeFromCart: function(ev) {
    ev.preventDefault();
    var id = $(ev.currentTarget).attr('data-id');

    jQuery
      .ajax({
        type: 'DELETE',
        url: '/cart',
        data: {
          product_id: id
        }
      })
      .then(function(data) {
        that.updateNavbarCart(data);
        that.updateCartPage(data);
        that.bindUIElements();

        return;
        // console.log("done");
        // console.log(data);
      })
      .catch(function(data) {
        // console.log('complete');
        // console.log(data);
      });
  }

  // updateProductPage: function (data) {

  //     //update page if needed
  //     that.checkIfInCart(data);

  // },

  // checkIfInCart: function (ajaxData) {

  //     var cart = window.cart;

  //     if (ajaxData) {
  //         cart = ajaxData.cart;
  //     };

  //     if (cart) {
  //         if (cart.items) {
  //             for (var i = 0; i < cart.items.length; i++) {
  //                 if (window.prod_id == cart.items[i].prod_id) {
  //                     that.changeText(cart.items[i].quantity);
  //                 }
  //             };
  //         }
  //     };

  //     return false;

  // },

  // changeText: function (quantity) {
  //     $("#add-to-cart-trigger").addClass("btn-success").val("+1 Add More");
  //     $("#quantity-in-cart").html(quantity);
  // },

  // updateCartPage: function (data) {
  //     var locals = data;
  //     var html = templateCheckoutCart(locals);
  //     $("#checkout-cart-item").html(html);
  // },
};

module.exports = ShoppingListController;



// WEBPACK FOOTER //
// ./public/src/js/shoppingList.js